import { API } from '@aws-amplify/api';
import { SkillFormData } from 'common/components/SkillModal';

export async function editSkill(data: SkillFormData, skillId: string): Promise<void> {
  try {
    const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
    const path = `api/skill/${skillId}`;
    const myInit = {
      body: data,
      headers: {},
    };

    const response = await API.put(apiName, path, myInit);
    if (!response) {
      throw new Error('Failed to edit skill');
    }
    return response;
  } catch (error) {
    console.error('Error editing skill:', error);
    throw error;
  }
}
